module.exports = __webpack_public_path__ + "img/products.02f1cd33.png";